import { render, staticRenderFns } from "./ProfileBtn.vue?vue&type=template&id=19284936&scoped=true&"
import script from "./ProfileBtn.vue?vue&type=script&lang=js&"
export * from "./ProfileBtn.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBtn.vue?vue&type=style&index=0&id=19284936&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19284936",
  null
  
)

export default component.exports